import {
  BOOKING_PAYMENT_START,
  BOOKING_PAYMENT_SUCCESS,
  BOOKING_PAYMENT_ERROR,
} from '../../constants';
import { sendPayment } from '../../core/payment/sendPayment';
import { convert, getFixedValue } from '../../helpers/currencyConvertion';
import { processStripePayment } from '../../core/payment/stripe/processStripePayment';
import showToaster from '../../helpers/showToaster';
import { createReservation as mutation } from '../../lib/graphql';

export function makePayment(
  listId,
  title,
  hostId,
  guestId,
  checkIn,
  checkOut,
  guests,
  message,
  basePrice,
  cleaningPrice,
  taxPrice,
  currency,
  discount,
  discountType,
  guestServiceFee,
  hostServiceFee,
  total,
  bookingType,
  paymentCurrency,
  paymentType,
  guestEmail,
  specialPricing,
  isSpecialPriceAssigned,
  isSpecialPriceAverage,
  dayDifference,
  paymentMethodId,
  taxRate,
  checkInStart,
  checkInEnd,
  hostServiceFeeType,
  hostServiceFeeValue,
  threadId,
  guestServiceFeeType,
  guestServiceFeeValue,
) {

  return async (dispatch, getState, { client }) => {

    dispatch({
      type: BOOKING_PAYMENT_START,
      payload: {
        paymentLoading: true
      }
    });

    try {
      let preApprove = getState().book.bookDetails.preApprove, bookingTypeData, cancellationPolicy = getState().book.data.listingData.cancellation.id;

      bookingTypeData = preApprove === true ? 'instant' : bookingType;

      const { data } = await client.mutate({
        mutation,
        variables: {
          listId: Number(listId),
          hostId,
          guestId,
          checkIn,
          checkOut,
          guests,
          message,
          basePrice,
          cleaningPrice,
          taxPrice,
          currency,
          discount,
          discountType,
          guestServiceFee,
          hostServiceFee,
          total,
          bookingType: bookingTypeData,
          paymentType: Number(paymentType),
          cancellationPolicy,
          specialPricing,
          isSpecialPriceAssigned,
          isSpecialPriceAverage: parseFloat(isSpecialPriceAverage),
          dayDifference,
          taxRate,
          checkInStart,
          checkInEnd,
          hostServiceFeeType,
          hostServiceFeeValue,
          threadId,
          guestServiceFeeType,
          guestServiceFeeValue,
        }
      })

      if (data?.createReservation) {
        let reservationId = data?.createReservation.id, amount = getFixedValue(total + guestServiceFee), rates = getState().currency.rates;
        let isAmount = 0;
        let baseCurrency = getState().currency.base, convertedAmount = 0, overAllAmount = amount && amount.toString().split(".")

        if (overAllAmount && overAllAmount[1] == "00") {
          isAmount = overAllAmount && overAllAmount[0];
        } else {
          isAmount = amount;
        }

        if (paymentType == 1) {
          convertedAmount = getFixedValue(convert(baseCurrency, rates, isAmount, currency, paymentCurrency));
          const { status, errorMessage } = await sendPayment(reservationId, convertedAmount, paymentCurrency, title);

          if (status === 200) {
            await dispatch({
              type: BOOKING_PAYMENT_SUCCESS,
              payload: { paymentLoading: true }
            });
          } else {
            if (status === 422) {
              showToaster({ messageId: 'paypalError', toasterType: 'error' })
            }
            else {
              errorMessage ? showToaster({ messageId: 'commonError', toasterType: 'error', requestContent: errorMessage }) : '';
            }
            await dispatch({
              type: BOOKING_PAYMENT_ERROR,
              payload: { paymentLoading: false }
            });
          }
        } else {
          let cardDetails = {};
          let reservationDetails = {
            reservationId,
            listId,
            hostId,
            guestId,
            guestEmail,
            title,
            amount,
            currency
          };
          const { status, errorMessage, paymentIntentSecret } = await processStripePayment(
            'reservation',
            cardDetails,
            reservationDetails,
            paymentMethodId
          );

          if (status === 200) {
            await dispatch({
              type: BOOKING_PAYMENT_SUCCESS,
              payload: { paymentLoading: true }
            });

            return {
              status
            }

          } else {
            errorMessage ? showToaster({ messageId: 'commonError', toasterType: 'error', requestContent: errorMessage }) : '';
            await dispatch({
              type: BOOKING_PAYMENT_ERROR,
              payload: { paymentLoading: false }
            });
            return {
              status,
              paymentIntentSecret,
              reservationId
            }
          }
        }
      }
    } catch (error) {
      dispatch({
        type: BOOKING_PAYMENT_ERROR,
        payload: {
          error,
          paymentLoading: false
        }
      });
      return false;
    }

    return true;
  };
}

